// src/Auth/authUtils.js
import { logoutMicrosoft } from "./AuthMicrosoft/authMicrosoft"
import { devError } from "../utils/devConsole"

/**
 * General logout function to handle both MySQL and Microsoft authentication.
 * @param {string} authMethod - The authentication method ("microsoft").
 * @param {object} instance - The MSAL instance (needed for Microsoft logout).
 * @param {function} navigate - The React Router navigation function.
 */
export const logout = async (authMethod, instance, navigate) => {
  try {

    // Disabilita le interazioni utente durante la disconnessione
    const loadingElement = document.createElement("div")
    loadingElement.id = "logout-overlay"
    loadingElement.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `
    loadingElement.innerHTML = '<div style="color: white; font-size: 20px;">Logout in progress...</div>'
    document.body.appendChild(loadingElement)

    if (authMethod === "microsoft" && instance) {
      await logoutMicrosoft(instance)
      // Nota: logoutMicrosoft gestisce già il reindirizzamento, quindi non dovremmo arrivare qui
    }

    // Pulisci lo storage locale dopo la disconnessione
    localStorage.removeItem("authToken")
    localStorage.removeItem("authMethod")
    localStorage.removeItem("connectionTime")

    // Rimuovi l'overlay di caricamento
    if (document.body.contains(loadingElement)) {
      document.body.removeChild(loadingElement)
    }

    // Prevenire un reindirizzamento multiplo verso la pagina principale
    if (window.location.pathname !== "/") {
      navigate("/") // Redirect to the home page after logout
    }
  } catch (error) {
    devError("Error during logout:", error)

    // In caso di errore, forza una disconnessione "brutale"
    localStorage.clear()
    sessionStorage.clear()

    // Rimuovi l'overlay di caricamento se esiste ancora
    const overlay = document.getElementById("logout-overlay")
    if (overlay) {
      document.body.removeChild(overlay)
    }

    window.location.href = "/"
  }
}
